module.exports = __webpack_public_path__ + "static/media/logo.d1d1a8c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 270
// module chunks = 0